import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export default function useCategoryData(categoryId) {
  const userId = auth.currentUser.uid;
  const [data, setData] = useState({});
  const [fullUserData, setFullUserData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const docRef = doc(db, "users", userId);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        const userData = snap.data();
        setFullUserData(userData);               // ⭐ store entire user object
        setData(userData[categoryId] || {});     // ⭐ store only this category
      }

      setLoading(false);
    }

    fetchData();
  }, [categoryId, userId]);

  const saveData = async (updatedCategoryData) => {
    const docRef = doc(db, "users", userId);

    const newUserData = {
      ...fullUserData,                // ⭐ keep all categories
      [categoryId]: updatedCategoryData,  // ⭐ update only this one
    };

    await setDoc(docRef, newUserData);   // ⭐ overwrite entire user object

    setFullUserData(newUserData);
  };

  return { data, setData, loading, saveData };
}
